import { jsx as _jsx } from "react/jsx-runtime";
import { I18nLookup } from 'pricing-pages-lib/utils/languageUtils';
import { PAYMENTS } from 'self-service-api/constants/Features';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIList from 'UIComponents/list/UIList';
import ChecklistItem from '../../common/ChecklistItem';

const BusinessObjectivesFeatures = ({
  features,
  productLine
}) => {
  return /*#__PURE__*/_jsx(UIList, {
    children: features.map(feature => {
      const nameVal = `pricing-pages.features.${feature.shortName}.name`;
      const secondaryMessage = feature.shortName === PAYMENTS ? 'merchCards.businessObjectives.usOnly' : undefined;
      const hasHubSpecificLanguage = I18nLookup(`pricing-pages.features.${feature.shortName}.description.${productLine}`);
      const keyToUse = hasHubSpecificLanguage ? productLine : 'default';
      const descriptionVal = `pricing-pages.features.${feature.shortName}.description.${keyToUse}`;
      return /*#__PURE__*/_jsx(UIFlex, {
        className: "m-y-1",
        children: /*#__PURE__*/_jsx(ChecklistItem, {
          tooltipMessage: descriptionVal,
          message: nameVal,
          secondaryMessage: secondaryMessage
        })
      }, feature.featureId); // @TODO reimplement once translations are available
      // const secondaryMessage =
      //   feature.shortName === PAYMENTS ? (
      //     <FormattedMessage message="merchCards.businessObjectives.usOnly" />
      //   ) : null;
      // return (
      //   <UIFlex key={feature.featureId} className="m-y-1">
      //     <ChecklistItemTranslated
      //       tooltipMessage={feature.description}
      //       message={feature.displayName}
      //       secondaryMessage={secondaryMessage}
      //     />
      //   </UIFlex>
      // );
    })
  });
};

export default BusinessObjectivesFeatures;